import { IJobExecutionHandler, IJobExecutionRunner, IJobTriggerRunner } from './index';

export abstract class ExecutionHandler implements IJobExecutionHandler {
    abstract handleJobTriggerResult(triggerResult: IJobTriggerRunner, handler?: () => void): void;
    abstract handleJobExecutionResult(execResult: IJobExecutionRunner, handler?: () => void): void;
}
